module.exports = __webpack_public_path__ + "img/微信粉丝.1cd68184.png";